import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, HelpCircle } from 'lucide-react';
import Button from '../components/ui/Button';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen theme-transition relative overflow-hidden flex items-center justify-center" style={{background: 'var(--liquid-gradient-bg)'}}>
      {/* Enhanced Liquid Glass Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-96 h-96 liquid-glass opacity-20 liquid-animate-morph"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 liquid-glass-strong opacity-15 liquid-animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 liquid-glass opacity-10 liquid-animate-wave" style={{animationDelay: '4s'}}></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-2xl mx-auto">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl sm:text-[12rem] font-bold liquid-glow-strong opacity-20" style={{color: 'var(--liquid-text-primary)'}}>
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 liquid-glow-strong" style={{color: 'var(--liquid-text-primary)'}}>
            Page Not Found
          </h2>
          <p className="text-lg sm:text-xl leading-relaxed opacity-80" style={{color: 'var(--liquid-text-muted)'}}>
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={() => navigate('/')}
            variant="primary"
            size="lg"
            className="flex items-center space-x-2"
          >
            <Home size={20} />
            <span>Go to Home</span>
          </Button>
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            size="lg"
            className="flex items-center space-x-2"
          >
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </Button>
        </div>

        {/* Quick Links */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-sm mb-4 opacity-70" style={{color: 'var(--liquid-text-muted)'}}>
            Popular pages:
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 glass-button rounded-xl text-sm hover:scale-105 transition-transform"
              style={{color: 'var(--liquid-text-primary)'}}
            >
              <Search size={16} className="inline mr-2" />
              Browse Events
            </button>
            <button
              onClick={() => navigate('/about')}
              className="px-4 py-2 glass-button rounded-xl text-sm hover:scale-105 transition-transform"
              style={{color: 'var(--liquid-text-primary)'}}
            >
              <HelpCircle size={16} className="inline mr-2" />
              About Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;




